export default __webpack_public_path__ + "static/media/juiceBar.971dc50c.webp";